document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('facetwp-loaded', () => {
		const searchField = document.querySelector('#search-field');

		if (searchField) {
			const searchTerm = searchField.querySelector('input').value;

			if (searchTerm !== null && searchTerm !== undefined && searchTerm !== '') {
				document.querySelector('.search #searchbox').textContent = searchTerm;
				document
					.querySelectorAll('.search-container .toggle, .search-results, .loadmore, .total-results')
					.forEach((element) => {
						element.classList.remove('hidden');
					});
			} else {
				document.querySelector('.search #searchbox').textContent = '';
				document
					.querySelectorAll('.search-container .toggle, .search-results, .loadmore, .total-results')
					.forEach((element) => {
						element.classList.add('hidden');
					});
			}
		}
	});
});
